import React, { useEffect, useRef, useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { testimonialImages } from '../../data/testimonialImages';
export function Testimonials() {
  const trackRef = useRef<HTMLDivElement>(null);
  const [itemsPerView, setItemsPerView] = useState(1);
  const [activeIndex, setActiveIndex] = useState(0);

  // Lightweight responsive check (no library): 1 image on mobile, 2 on desktop.
  useEffect(() => {
    const updateItemsPerView = () => setItemsPerView(window.innerWidth >= 640 ? 2 : 1);
    updateItemsPerView();
    window.addEventListener('resize', updateItemsPerView);
    return () => window.removeEventListener('resize', updateItemsPerView);
  }, []);
  const maxIndex = Math.max(0, testimonialImages.length - itemsPerView);
  const scrollToIndex = (index: number) => {
    const clamped = Math.min(Math.max(index, 0), maxIndex);
    const track = trackRef.current;
    const item = track?.children[clamped] as HTMLElement | undefined;
    if (track && item) {
      track.scrollTo({
        left: item.offsetLeft,
        behavior: 'smooth'
      });
    }
    setActiveIndex(clamped);
  };

  // Keeps the dots/arrow state in sync when the user swipes by hand.
  const handleScroll = () => {
    const track = trackRef.current;
    const first = track?.children[0] as HTMLElement | undefined;
    if (!track || !first) return;
    const itemWidth = first.offsetWidth + 16;
    const index = Math.round(track.scrollLeft / itemWidth);
    setActiveIndex(Math.min(Math.max(index, 0), maxIndex));
  };
  return <section className="bg-navy py-10 sm:py-14" data-id="element-203" data-mp="26i7m9c8elsmb">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-204" data-mp="22hxg9zkm327g">
        <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-4 py-1.5 text-xs font-bold uppercase tracking-wider text-white sm:text-sm" data-id="element-205" data-mp="1xjm95wlpb5sx">
          <span aria-hidden="true" data-id="element-206" data-mp="r178ic0ji2bq">⭐</span>
          Testimonios reales
        </span>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-white sm:text-4xl" data-id="element-207" data-mp="m35s5yui0h3y">
          Así están usando el material otros profesores
        </h2>
      </div>

      <div className="mx-auto mt-8 flex max-w-5xl items-center gap-2 px-2 sm:gap-4 sm:px-6" data-id="element-208" data-mp="sjxrg78i0u4x">
        <button type="button" onClick={() => scrollToIndex(activeIndex - 1)} disabled={activeIndex === 0} aria-label="Testimonio anterior" className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition-colors hover:bg-white/20 disabled:opacity-30 disabled:pointer-events-none" data-id="element-209" data-mp="ekocfaw1462j">
          <ChevronLeftIcon size={20} data-id="element-210" data-mp="3r09uhihc6nfg" />
        </button>

        <div ref={trackRef} onScroll={handleScroll} className="scrollbar-hide flex flex-1 snap-x snap-mandatory gap-4 overflow-x-auto scroll-smooth" data-id="element-211" data-mp="3w2hb4ld42ro4">
          {testimonialImages.map((src, i) => <div key={src} className="flex h-[380px] w-full flex-shrink-0 snap-start items-center justify-center rounded-2xl bg-white p-3 shadow-card sm:h-[440px] sm:w-[calc(50%-8px)]" data-id="element-212" data-mp="3n2u85v4qhdsy" data-mpi={i}>
              <img src={src} alt={`Testimonio real de un profesor de Educación Física sobre EF-FLASH — captura ${i + 1} de ${testimonialImages.length}`} loading="lazy" decoding="async" className="h-full w-full rounded-xl object-contain" data-id="element-213" data-mp="3cfe3z2l676k8" />
            </div>)}
        </div>

        <button type="button" onClick={() => scrollToIndex(activeIndex + 1)} disabled={activeIndex === maxIndex} aria-label="Siguiente testimonio" className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full border border-white/15 bg-white/10 text-white transition-colors hover:bg-white/20 disabled:opacity-30 disabled:pointer-events-none" data-id="element-214" data-mp="3hcmnp7lyvinl">
          <ChevronRightIcon size={20} data-id="element-215" data-mp="1yg2nkz6mi36v" />
        </button>
      </div>

      <div className="mt-6 flex items-center justify-center gap-2" role="tablist" aria-label="Seleccionar testimonio" data-id="element-216" data-mp="1yfsvn620plyj">
        {testimonialImages.map((src, i) => <button key={src} type="button" role="tab" onClick={() => scrollToIndex(i)} aria-label={`Ir al testimonio ${i + 1}`} aria-selected={i === activeIndex} className={`h-2 rounded-full transition-all duration-200 ${i === activeIndex ? 'w-6 bg-yellow' : 'w-2 bg-white/30'}`} data-id="element-217" data-mp="286x7vy0b6spo" data-mpi={i} />)}
      </div>
    </section>;
}